export default __webpack_public_path__ + "static/media/icon-cashback-cycle.ca7c1459.svg";